import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { ChevronDownIcon } from '@app/pages/Prototype/icons';

export const DROPDOWN_WIDTH_OPEN = '360px';
export const CHEVRON_WIDTH = 32;

// Wrapper component
export const DropdownPanelWrapper = styled.div`
    position: relative;
    z-index: 10;
`;

// Container component that is absolute positioned so that it overlays
export const DropdownPanelContainer = styled(motion.div)<{ $isRelative?: boolean }>`
    position: absolute;
    display: inline-flex;
    flex-direction: column;
    border-radius: 24px;
    cursor: pointer;
    overflow: hidden;

    ${({ $isRelative }) =>
        $isRelative &&
        css`
            position: relative;
        `}
`;

export const DropdownPanelTrigger = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
`;

export const DropdownPanelContent = styled.div`
    width: ${DROPDOWN_WIDTH_OPEN};
    display: flex;
    flex-direction: column;
    margin-left: -10px;
`;

export const ChevronWrapper = styled(motion.div)`
    display: flex;
    width: ${CHEVRON_WIDTH}px;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const Chevron = styled(ChevronDownIcon)`
    width: 12.5px;
    fill: transparent !important;
`;
